import { handleActions } from 'redux-actions'
import { setCompanyDiseases } from './actionCreators'

const initialState = {
  diseases: []
}

export default handleActions(
  {
    [`${setCompanyDiseases}`](state: any, { payload: diseases = [] }: any) {
      return diseases
    }
  },
  initialState
)
